
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

import heroImg from '../../../assets/godrejIndore/mainFeed.jpg'
import logo from '../../../assets/godrejIndore/logo.png'

import interior1 from '../../../assets/godrejIndore/interior-1.png'
import interior2 from '../../../assets/godrejIndore/interior-2.png'
import interior3 from '../../../assets/godrejIndore/interior-3.png'
import interior4 from '../../../assets/godrejIndore/interior-4.png'
import interior5 from '../../../assets/godrejIndore/interior-5.png'

import ameneties1 from '../../../assets/godrejIndore/ameneties-1.webp'
import ameneties2 from '../../../assets/godrejIndore/ameneties-2.webp'
import ameneties3 from '../../../assets/godrejIndore/ameneties-3.jpg'
import ameneties4 from '../../../assets/godrejIndore/ameneties-4.jpg'
import ameneties5 from '../../../assets/godrejIndore/ameneties-5.avif'

import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';


const GodrejIndore = () => {
  const location = useLocation();
  const [openImgModal, setOpenImgModal] = useState(false);

  const [selectedImgIndex, setSelectedImgIndex] = useState(null);
  const [activeImageType, setActiveImageType] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const interiors = [interior1, interior2, interior3, interior4, interior5]
  const ameneties = [ameneties1, ameneties2, ameneties3, ameneties4, ameneties5]


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);


  const handleOpenModal = (index, type) => {
    setSelectedImgIndex(index);
    setActiveImageType(type);
    setOpenImgModal(true);
  }

  return (
    <div className="w-full min-h-screen bg-gray-100">
      <div
        className="w-full h-[700px] bg-cover bg-center transition-all duration-500"
        style={{ backgroundImage: `url('${heroImg}')` }}
      ></div>

      <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
        <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
          <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
        </div>
      </div>

      <div class="flex flex-col md:flex-row px-2.5 gap-4">
        <div class="w-full md:w-2/3 flex flex-col gap-4">
          <div className="">
            <div className="max-w-5xl mx-auto p-6">
              <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                Godrej Riverine is an exclusive luxury residential project by Godrej Properties, located in the prime Sector 44 of Noida. This project is inspired by the journey of a river, symbolizing grace, harmony, and continuous growth. Here’s a detailed overview:
              </p>

              <h2 className="text-2xl md:text-3xl font-bold my-2">Key Features:</h2>
              <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Location:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    Strategically situated on the Indore-Ujjain Highway, the project ensures excellent connectivity to Indore's key landmarks, including the Super Corridor, Pithampur Industrial Area, and Indore International Airport. It is also close to Ujjain, making it a prime location for residents and investors.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Land Area:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    Spread across a sprawling 46-acre land parcel, the project offers ample space for a well-planned community.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Plot Sizes:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    The development features plots ranging from 900 sq. ft. to 1500 sq. ft., catering to diverse needs and preferences.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Amenities:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    Residents can enjoy world-class amenities such as a modern clubhouse, landscaped gardens, jogging tracks, a swimming pool, outdoor sports courts, a gymnasium, and a dedicated children's play area.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Security:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    The project boasts a gated community with 5-tier security, ensuring a safe and peaceful environment for residents.
                  </p>
                </div>
              </section>


              <h2 className="text-2xl md:text-3xl font-bold my-4">Highlights :</h2>
              <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Nature-Centric Living:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    The project is surrounded by manicured parks and green spaces, offering a tranquil and rejuvenating lifestyle.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Investment Potential:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    With its strategic location and premium features, Godrej Indore Plots is an excellent investment opportunity, promising high returns in the future.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Connectivity :</h3>
                  <p className="text-md text-gray-700 text-justify">
                    The project is well-connected to major cities like Bhopal, Delhi, and Bangalore, as well as local landmarks such as the Mahakaleshwar Temple and Aurobindo Medical Institute.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Why Choose Godrej Indore Plots?</h3>
                  <p className="text-md text-gray-700 text-justify">
                    Developed by Godrej Properties, a trusted name in real estate, known for its commitment to quality and innovation.
                  </p>
                  <p className="text-md text-gray-700 text-justify mt-2">
                    Offers a perfect blend of luxury, comfort, and convenience, making it an ideal choice for building your dream home or making a strategic investment.
                  </p>
                  <p className="text-md text-gray-700 text-justify mt-2">
                    Located in Indore, one of India's cleanest and fastest-growing cities, with robust infrastructure and a thriving real estate market.
                  </p>
                </div>
              </section>
              <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                This project is a testament to Godrej Properties' vision of creating sustainable and luxurious living
                spaces. Whether you're looking to build a family home or invest in a promising location, Godrej
                Indore Plots offers an unparalleled opportunity.
              </p>
            </div>
          </div>
        </div>
        <ConnectForm />
      </div>
      <div className="max-w-7xl mx-auto p-4">
        <h2 className="text-2xl font-semibold text-gray-800 my-4">
          Projects Highlights
        </h2>
        {openImgModal && activeImageType === "ameneties" && (
          <ImageModal
            images={ameneties}
            openImg={openImgModal}
            selectedImgIndex={selectedImgIndex}
            onClose={() => setOpenImgModal(false)}
          />
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {ameneties.map((data, index) => (
            <div
              key={index}
              onClick={() => handleOpenModal(index, "ameneties")}
              className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
            >
              <img
                src={data}
                alt="ATS"
                className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
              />
            </div>
          ))}
        </div>
      </div>
      <h2 className="text-2xl font-semibold text-gray-800 p-4">
        Luxury  Insights
      </h2>
      {openImgModal && activeImageType === "interiors" && (
        <ImageModal
          images={interiors}
          openImg={openImgModal}
          selectedImgIndex={selectedImgIndex}
          onClose={() => setOpenImgModal(false)}
        />
      )}

      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
        {interiors.map((data, index) => (
          <div
            key={index}
            onClick={() => handleOpenModal(index, "interiors")}
            className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
          >
            <img
              src={data}
              alt="ATS"
              className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
            />
          </div>
        ))}
      </div>
    </div>
  )
}
export default GodrejIndore